module.exports = __webpack_public_path__ + "img/mapa_inactive.a0015221.svg";